import { render, staticRenderFns } from "./PublicDetailDialog.vue?vue&type=template&id=69588cda&scoped=true&"
import script from "./PublicDetailDialog.vue?vue&type=script&lang=js&"
export * from "./PublicDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./PublicDetailDialog.vue?vue&type=style&index=0&id=69588cda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69588cda",
  null
  
)

export default component.exports